import { graphql } from "~/gql";

export const BEDROCK_SUGGEST_EXCLUSIONS_QUERY = graphql(/* GraphQL */ `
  query BedrockSuggestExclusions($matterId: Float!) {
    bedrockSuggestExclusions(matterId: $matterId) {
      chosen
      suggested
    }
  }
`);
